export default __webpack_public_path__ + "static/AiDesigner-4b6dd4a051e52b2c93ec26ebf3281638.mp4";